import React from 'react';
import { Building2, ArrowDown } from 'lucide-react';

const MiniCaseStudies = () => {
  const cases = [
    {
      client: 'Naus',
      before: 'Proposta única de R$ 253.000 para gramado sintético.',
      after: 'A dgenny encontrou e homologou novos fornecedores. Compra fechada por R$ 183.000.',
      result: 'R$ 70.000 de economia em uma única compra.',
      savings: '30%',
    },
    {
      client: 'Tauf',
      before: 'EPIs em volume, poucos fornecedores, equalização travada.',
      after: 'A dgenny negociou em paralelo e equalizou item por item. Melhor preço identificado sozinho.',
      result: '23% abaixo do preço médio de mercado.',
      savings: '23%',
    },
  ];

  return (
    <section id="cases" className="py-20 md:py-28 bg-white">
      <div className="container px-4 mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="inline-block text-brand-roxo font-semibold text-sm uppercase tracking-wider mb-3">
            Casos
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-extrabold text-brand-azul leading-tight">
            Antes e depois da dgenny
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {cases.map((caseStudy, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 border border-border hover:border-brand-roxo/40 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-xl bg-brand-roxo/10 flex items-center justify-center">
                  <Building2 className="h-5 w-5 text-brand-roxo" />
                </div>
                <h3 className="font-display text-xl font-bold text-brand-azul">{caseStudy.client}</h3>
                <div className="ml-auto bg-brand-rosa/40 text-brand-azul px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider">
                  −{caseStudy.savings}
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-muted/60 rounded-xl p-4">
                  <p className="text-xs font-bold text-brand-azul/50 uppercase tracking-wider mb-1">Antes</p>
                  <p className="text-brand-azul/80">{caseStudy.before}</p>
                </div>

                <div className="flex justify-center">
                  <ArrowDown className="h-5 w-5 text-brand-roxo" />
                </div>

                <div className="bg-brand-roxo/5 border border-brand-roxo/20 rounded-xl p-4">
                  <p className="text-xs font-bold text-brand-roxo uppercase tracking-wider mb-1">Depois</p>
                  <p className="text-brand-azul">{caseStudy.after}</p>
                </div>

                <div className="bg-brand-azul p-5 rounded-xl text-center">
                  <p className="font-display font-bold text-white text-lg">{caseStudy.result}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MiniCaseStudies;
